import { graphql } from 'relay-runtime'
import {
  Selects,
  SimpleSelectPanelProps
} from '@lifedot/components/SelectPanels'
import router from 'next/router'
import { router as routing } from '@lifedot/router'
import { useQuery } from 'relay-hooks/lib/useQuery'
import { useCallback, useMemo, useState } from 'react'
import {
  dependencies_useCitiesModalQuery,
  dependencies_useCitiesModalQuery$data
} from './__generated__/dependencies_useCitiesModalQuery.graphql'
import { Condition } from '@lifedot/constants/searchChoices'

export const useCitiesModal = (
  prefecture: string,
  condition: Condition,
  region: string
): [
  { items: SimpleSelectPanelProps['items']; disabled: boolean },
  {
    onSubmit: (arg: Selects) => Promise<boolean>
    onChange: (arg: Selects) => void
  }
] => {
  const [disabled, setDisabled] = useState(true)
  const { data } = useQuery<dependencies_useCitiesModalQuery>(
    query,
    {
      prefecture,
      region,
      choice: condition.code
    },
    {}
  )
  const items = useMemo(() => makeItem(data), [data])
  const onChange = useCallback(
    (selected: Selects) => setDisabled(selected.length < 1),
    []
  )
  const onSubmit = useCallback(
    (selected: Selects) =>
      router.push(
        routing.list({
          prefectureRoma: prefecture,
          cityId: selected.map(Number),
          condition: {
            code: condition.code,
            attributeCode: condition.attributeCode
          }
        })
      ),
    [condition.code, condition.attributeCode, prefecture]
  )

  return [
    { items, disabled },
    { onChange, onSubmit }
  ]
}

const query = graphql`
  query dependencies_useCitiesModalQuery(
    $prefecture: String!
    $region: String!
    $choice: String!
  ) {
    listCitiesWithCemeteryCount(
      filter: {
        regionCode: { eq: $region }
        prefectureRoma: { eq: $prefecture }
      }
      cemeteryFilter: { choices: [$choice] }
      limit: 999
    ) {
      items {
        cityId: id
        name
        cemeteryCount
      }
    }
  }
`

const makeItem = (
  data: dependencies_useCitiesModalQuery$data | null | undefined
): SimpleSelectPanelProps['items'] =>
  data?.listCitiesWithCemeteryCount?.items?.map(
    ({ cityId, name, cemeteryCount }) => ({
      value: String(cityId),
      name: `${name}(${cemeteryCount})`,
      disabled: cemeteryCount < 1
    })
  ) ?? []
